// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';

import Header from './Header.jsx';
import Body from './Body.jsx';
import Sidebar from './Sidebar.jsx';

import { fetchRequest, setCurrentRequest, EMPTY_REQUEST } from '..';
import { loadQueue } from '../../queue';


function Request(props) {
	let { key } = useParams();
    const dispatch = useDispatch();
    const [showing, setShowing] = useState(true);
    const request = useSelector(state => {
        return state.requests.byKey[key] || EMPTY_REQUEST;
    });
    
    useEffect(() => {
        
        if(!request.key || (request.key != key)) {
            // FIXME: this will not work if the request is not in thier queue
            // load the request and set it into cache if it's not in the queue.
            // with a warning... etc.
            dispatch(fetchRequest(key)).
                then((data) => {
                    console.log(data);
                });
        }
        
        if(request.key) {
            console.warn("setting currenet request, have key");
            dispatch(setCurrentRequest(request));
        }
        else {
            console.warn("not settting current request. no key");
        }
        
        return function(data) {
            console.log("should unload request?");
        };
    }, [dispatch]);

    return(
        <Container>
          <Grid container direction="column">
            <Grid container >
              <Header request={request} />
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} md={7} style={{ marginBottom: 32 }}>
                <Body requestKey={key} request={request} />
              </Grid>
              <Grid item xs={12} md={5} >
                <Sidebar request={request} />
              </Grid>
            </Grid>
          </Grid>
        </Container>
    );
}

export { Request };
